import { Button, Typography } from "@mui/material"
import { Link, useLocation, useParams } from "react-router-dom"
import { skipToken } from "@reduxjs/toolkit/query"
import type { TemplateWriteAccess } from "../hooks/useVersionDraft"
import { useGetTemplateQuery } from "../services/publications/templatesApi"
import { PostBotNavigation } from "../components/common/postBotNavigation"
import { TemplateVersionsTable } from "../components/templates/templateVersionsTable"
import { PostBotPageLayout } from "../components/common/postBotPageLayout"
import { TemplateQueryFeedback } from "../components/templates/templateQueryFeedback"
import {
  newTemplateVersionPath,
  readTemplateReturnContext,
  templatesPath,
} from "../components/templates/templateNavigation"

export interface TemplatePageProps extends TemplateWriteAccess {
  templateId?: string
}
/** Supports :templateId (or :id) and an explicit ID for embedded hosts. */
export default function TemplatePage(props: TemplatePageProps) {
  const params = useParams()
  const templateId = props.templateId ?? params.templateId ?? params.id
  return (
    <TemplateDetail
      key={templateId ?? "missing"}
      {...props}
      templateId={templateId}
    />
  )
}
function TemplateDetail({ templateId, ...access }: TemplatePageProps) {
  const { state } = useLocation()
  const returnContext = readTemplateReturnContext(state)
  const query = useGetTemplateQuery(templateId ?? skipToken)
  const template =
    query.currentData?.id === templateId ? query.currentData : undefined
  return (
    <PostBotPageLayout>
      <PostBotNavigation />
      <Button
        component={Link}
        to={templatesPath}
        state={returnContext}
        sx={{ alignSelf: "flex-start" }}
      >
        Библиотека шаблонов
      </Button>
      <TemplateQueryFeedback
        query={query}
        empty={!template && "Шаблон не найден"}
      />
      {template && (
        <>
          <Typography variant="h5">{template.name}</Typography>
          {!access.readOnly && access.canWrite !== false && (
            <Button
              component={Link}
              to={newTemplateVersionPath(template.id)}
              state={returnContext}
              sx={{ alignSelf: "flex-start" }}
            >
              Редактирование
            </Button>
          )}
          <TemplateVersionsTable
            templateId={template.id}
            returnContext={returnContext}
          />
        </>
      )}
    </PostBotPageLayout>
  )
}
